import ButtonEdge from './ButtonEdge';


export const edgeTypes = {
  buttonedge: ButtonEdge,
};
